// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"df60ee04c83a5cbd3535","293":"b23cf388728b4a9f495d","518":"2ad06faa6edba10df4c0","779":"65c3420001aaba05d9d5"}[chunkId] + ".js";
};